import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle
} from '@/components/ui/dialog';
import { Button } from '../ui/button';
import { PropsWithChildren, ReactNode } from 'react';
import { DialogTrigger } from '@radix-ui/react-dialog';
import Spinner from '../spinner/Spinner';

export type ConfirmationModalProps = {
	isOpen?: boolean;
	title: string;
	body?: ReactNode;
	cancelBtnLabel?: ReactNode;
	confirmBtnLabel?: ReactNode;
	handleClose?: () => void;
	handleConfirm?: () => void;
	isDisabled?: boolean;
	errorMessage?: string;
	trigger?: ReactNode;
	isLoading?: boolean;
} & PropsWithChildren;

const ConfirmationModal = (props: ConfirmationModalProps) => {
	const {
		isOpen = false,
		title,
		errorMessage,
		cancelBtnLabel,
		confirmBtnLabel,
		body,
		handleClose,
		handleConfirm,
		isDisabled,
		children,
		trigger,
		isLoading
	} = props;

	return (
		<Dialog open={isOpen} onOpenChange={handleClose}>
			{trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{body}</DialogDescription>
				</DialogHeader>
				{children}
				<DialogFooter>
					<Button className="min-w-30" variant="secondary" onClick={handleClose}>
						{cancelBtnLabel ?? 'Cancel'}
					</Button>
					<Button className="min-w-30" variant="destructive" onClick={handleConfirm} disabled={isDisabled}>
						{(!isLoading && confirmBtnLabel) ?? 'Confirm'}
						{isLoading && <Spinner className="ml-2" />}
					</Button>
				</DialogFooter>
				{errorMessage && (
					<p className="text-[0.8rem] font-medium text-red-500 text-end w-full">{errorMessage}</p>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default ConfirmationModal;
